
export const documents = {
  '1': [
    { id: '1', category: 'ID Document', fileName: 'id.pdf', fileURL: '#', status: 'pending', uploadedAt: new Date(), rejectionComment: null },
    { id: '2', category: 'Qualifications', fileName: 'qualifications.pdf', fileURL: '#', status: 'verified', uploadedAt: new Date(), rejectionComment: null },
  ],
  '2': [
    { id: '3', category: 'Affidavit', fileName: 'affidavit.pdf', fileURL: '#', status: 'rejected', uploadedAt: new Date(), rejectionComment: 'Document is not certified.' },
  ],
};
